import Com from '../src/components/PaperDownloadButton.vue'
import Vue from 'vue'

const elms = document.getElementsByTagName('paper-download-button')

for (const elm of elms) {
  new Vue({
    render: h => h(Com)
  }).$mount(elm)  
}

export default Com

